<template>
  <b-modal
    :visible="value"
    :title="title"
    size="sm"
    hide-footer
    centered
    @change="modalChangeEvent"
  >
    <CodigoPostalForm
      :data="formData"
      :editing="isEditing"
      @update="updateForm"
      :errors="formErrors"
      :zonasSelector="zonasParaSelector"
    />

    <BfButton v-if="!isEditing" @click="createCodigoPostal">
      Guardar
    </BfButton>
  </b-modal>
</template>

<script>
import CodigoPostalForm from '@/components/FormGroups/CodigoPostalForm'
import { codigosPostalesApi } from '@/api'

export default {
  name: 'CreateCodigoPostalModal',
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    value: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
    },
  },
  data() {
    return {
      formData: {},
      formErrors: {},
      loadingData: false,
      displayDeleteModal: false,
      zonasParaSelector: undefined,
    }
  },

  created() {
    this.prepareForm()
  },

  methods: {
    async updateForm({ key, value }) {
      const newData = { [key]: value }

      this.formData = {
        ...this.formData,
        ...newData,
      }
    },
    async createCodigoPostal() {
      try {
        this.formErrors = {}
        const { data, message } = await codigosPostalesApi.create(this.formData)

        this.$bfNotify({ title: 'Guardado', message, type: 'success' })
        this.modalChangeEvent(false)
        this.formData= {}
        //  this.$router.replace({ name: 'codigosPostales' })
      } catch ({ errors, message }) {
        this.formErrors = errors
        this.$bfNotify({
          title: 'Error',
          message: 'Existe un error con tus datos',
          type: 'error',
        })
      }
    },
    async prepareForm() {
      const { zonas } = await codigosPostalesApi.preCreate()

      this.zonasParaSelector = zonas.map(({ nombre, id }) => ({
        label: nombre,
        value: id,
      }))
    },
    modalChangeEvent(visible) {
      this.$emit('input', visible)
    },
  },
  components: {
    CodigoPostalForm,
    codigosPostalesApi,
  },
}
</script>
